import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import { arrayOf, number, oneOf, oneOfType, string } from 'prop-types';
import Flex from '../../atoms/Flex';
import SelectRating from '../../atoms/SelectRating';
import Text from '../../atoms/Text';
import TextInput from '../../atoms/Input';
import Confirm from '../Confirm';
const inputTypes = {
  rating: SelectRating,
  text: TextInput,
  recommendation: Confirm
};
const ReviewInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    label,
    type,
    error,
    flexDirection,
    fontSize,
    fontWeight,
    alignItems,
    textAlign,
    gap
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["label", "type", "error", "flexDirection", "fontSize", "fontWeight", "alignItems", "textAlign", "gap"]);

  const Input = inputTypes[type] || TextInput;
  return /*#__PURE__*/React.createElement(Flex, {
    "data-testid": "review-input-wrapper",
    flexDirection: flexDirection,
    gap: gap,
    width: 1
  }, /*#__PURE__*/React.createElement(Text, {
    "data-testid": "review-input-label",
    flex: "0.75",
    textAlign: textAlign,
    fontSize: fontSize,
    fontWeight: fontWeight,
    lineHeight: "input",
    paddingY: "2"
  }, label), /*#__PURE__*/React.createElement(Flex, {
    gap: "2",
    flex: "1",
    alignItems: alignItems,
    flexDirection: ['column', ['recommendation', 'rating'].includes(type) ? 'row' : 'column'],
    "data-testid": "review-input-container"
  }, /*#__PURE__*/React.createElement(Input, _extends({
    ref: ref
  }, !['rating', 'recommendation'].includes(type) && {
    hasError: !!error
  }, type === 'textarea' && {
    multiline: true
  }, props)), error && /*#__PURE__*/React.createElement(Text, {
    color: "error.base"
  }, error)));
});
ReviewInput.defaultProps = {
  error: null,
  flexDirection: null,
  fontSize: 2,
  fontWeight: 'regular',
  gap: 30,
  label: null,
  textAlign: 'right',
  alignItems: 'start'
};
process.env.NODE_ENV !== "production" ? ReviewInput.propTypes = {
  error: string,
  label: string,
  flexDirection: oneOfType([string, arrayOf(string)]),
  fontSize: oneOfType([string, number, arrayOf(string), arrayOf(number)]),
  fontWeight: oneOfType([string, number, arrayOf(string), arrayOf(number)]),
  alignItems: oneOfType([string, arrayOf(string)]),
  textAlign: oneOfType([string, arrayOf(string)]),
  gap: oneOfType([string, number, arrayOf(oneOfType([string, number]))]),
  type: oneOf(['rating', 'recommendation', 'text', 'textarea']).isRequired
} : void 0;
ReviewInput.displayName = 'ReviewInput';
export default ReviewInput;